import { render, staticRenderFns } from "./LockedControl.vue?vue&type=template&id=aa003984&scoped=true&"
import script from "./LockedControl.vue?vue&type=script&lang=js&"
export * from "./LockedControl.vue?vue&type=script&lang=js&"
import style0 from "./LockedControl.vue?vue&type=style&index=0&id=aa003984&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa003984",
  null
  
)

export default component.exports